import PrivateRoute from "@/router/PrivateRoot";
import TeacherDashboardPage from "@/pages/teacher/dashboard/teacherDashboardPage";
import ErrorPage from "@/components/error/ErrorPage";
import TeacherProfilePage from "@/pages/teacher/profile/teacherProfilePage";
import TeacherWeeklyPage from "@/pages/teacher/weekly/weeklyPage";
import {Outlet} from "react-router-dom";
import TeacherLessonListPage from "@/pages/teacher/lessons/dashboard/lessonListPage";
import TeacherShowLessonPage from "@/pages/teacher/lessons/[id]/TeacherShowLessonPage";

import NotificationsPage from "@/pages/notification/notificationsPage";
import TeacherTimesListPage from "@/pages/teacher/times/TeacherTimesListPage";
import TeacherReportListPage from "@/pages/teacher/reports/TeacherReportListPage";
import React from "react";
import TeacherStudentListPage from "@/pages/teacher/lessons/[id]/students/TeacherStudentListPage";
import TeacherAttendanceListPage from "@/pages/teacher/lessons/[id]/attendance/TeacherAttendanceListPage";
import TeacherReportCreatePage from "@/pages/teacher/reports/ create/TeacherReportCreatePage";
import TeacherStudentListPrintPage from "@/pages/teacher/lessons/[id]/print/TeacherStudentListPrintPage";
import TeacherStudentScorePage from "@/pages/teacher/lessons/[id]/score/TeacherStudentListPage";
import TeacherLessonHomeworkPage from "@/pages/teacher/lessons/[id]/homework/TeacherStudentListPage";
import TeacherHomeworkCreatePage from "@/pages/teacher/lessons/[id]/homework/create/TeacherHomeworkCreatePage";
import TeacherHomeworksList from "@/pages/teacher/homeworks/TeacherHomeworksListPage";
import TeacherHomeworkEditPage from "@/pages/teacher/homeworks/[id]/TeacherHomeworkEditPage";
import TeacherModeratorPage from "@/pages/teacher/lessons/[id]/moderator/TeacherModeratorPage";
import TeacherShowStudentProfilePage
    from "@/pages/teacher/lessons/[id]/students/[student_id]/TeacherShowStudentProfilePage";


export const TeacherRoute = [
    {
        path: '/teacher',
        element: <PrivateRoute module={'teacher'}/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                element: <TeacherDashboardPage/>,
            },

            {
                path: 'profile',
                element: <TeacherProfilePage/>,
            },

            {
                path: 'notifications',
                element: <NotificationsPage module={'teacher'}/>,
            },

            {
                path: 'weekly',
                element: <TeacherWeeklyPage/>,
            },

            {
                path: 'times',
                element: <TeacherTimesListPage/>,
            },

            {
                path: 'reports',
                element: <TeacherReportListPage/>,
            },
            {
                path: 'reports/create',
                element: <TeacherReportCreatePage/>,
            },

            {
                path: 'homeworks',
                element: <TeacherHomeworksList/>,
            },
            {
                path: 'homeworks/:id',
                element: <TeacherHomeworkEditPage/>,
            },


            {
                path: 'lessons',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <TeacherLessonListPage/>,
                    },
                    {
                        path: ':id',
                        element: <Outlet/>,
                        children: [
                            {
                                index: true,
                                element: <TeacherShowLessonPage/>,
                            },
                            {
                                path: 'students',
                                element: <TeacherStudentListPage/>
                            },
                            {
                                path: 'students/:studentId',
                                element: <TeacherShowStudentProfilePage/>
                            },
                            {
                                path: 'print',
                                element: <TeacherStudentListPrintPage/>
                            },
                            {
                                path: 'attendance',
                                element: <TeacherAttendanceListPage/>
                            },
                            {
                                path: 'moderator',
                                element: <TeacherModeratorPage/>
                            },
                            {
                                path: 'score',
                                element: <TeacherStudentScorePage/>
                            },

                            {
                                path: 'homeworks',
                                element: <TeacherLessonHomeworkPage/>
                            },
                            {
                                path: 'homeworks/create',
                                element: <TeacherHomeworkCreatePage/>
                            },
                            {
                                path: 'homeworks/:homeworkId',
                                element: <TeacherHomeworkCreatePage/>
                            }
                        ]
                    }


                ]
            },

        ],
    },
]
